<template>
	<div>
		<el-dialog title=" " :visible.sync="dialogVisible" :width="headerShow?'40%':'80%'"
			:top="headerShow?'calc(50vh - 187.5px)':'calc(50vh - 225px)'" :before-close="handleClose">
			<div class="pwdModelBox">
				<div class="pwdModelBoxOne">Download Password</div>
				<!-- <div class="pwdModelBoxTwo">
			  Password incorrect, please try again.
		  </div> -->
				<div class="pwdModelBoxThree">
					<el-input v-model="pwdDown" :type="typePwd=='look'?'password':'text'" placeholder="Please enter the download password">
						<template #suffix>
							<!-- <i class="el-input__icon el-icon-view"></i> -->
							<div class="pwdModelBoxThreeImg">
								<img src="../assets/hide.png" @click="typePwd='hide'" v-if="typePwd=='look'" />
								<img src="../assets/look.png" @click="typePwd='look'" v-else />
							</div>
						</template>

					</el-input>
				</div>
				<div class="pwdModelBoxFour">
					{{color_page_text}}
				</div>
				<div class="pwdModelBoxFive">
					<div @click="goSubmit">Submit</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		check_cy_pwd_api
	} from "@/api/config.js"
	import store from '@/store'
	export default {
		components: {

		},
		data() {
			return {
				dialogVisible: false,
				pwdDown: '',
				id: '',
				headerShow: true,
				color_page_text: 'If a download password is required,please contact the sales representative in your region.Thank you.',
				typePwd:'look',
				file_id:''
			}
		},
		mounted() {

		},
		computed: {
			nowVibe() {
				return store.state.nowVibe
			},
		},
		methods: {
			goInit(e,file_id) {
				if (this.nowVibe == 'pc') {
					if (window.innerWidth >= 1200) {
						this.headerShow = true;
						localStorage.setItem('headerShow', this.headerShow);
					} else {
						this.headerShow = false;
						localStorage.setItem('headerShow', this.headerShow);
					}
				} else {
					if (window.screen.width >= 1200) {
						this.headerShow = true;
						localStorage.setItem('headerShow', this.headerShow);
					} else {
						this.headerShow = false;
						localStorage.setItem('headerShow', this.headerShow);
					}
				}
				this.pwdDown = '';
				this.color_page_text = e;
				this.id = this.getUrlValue('id');
				this.file_id= file_id;
				this.dialogVisible = true;
			},
			getUrlValue(e) {
				const url = new URL(window.location.href);
				const params = new URLSearchParams(url.search);
				return params.get(e)
			},
			handleClose() {
				this.dialogVisible = false;
			},
			goSubmit() {
				let t = this;
				if (!this.pwdDown) {
					const screenHeight = window.innerHeight;
					
					// 计算可视区域高度的 20%
					const twentyPercentHeight = screenHeight * 0.22;
					this.$message({
						type:'error',
						message:'The download password cannot be empty',
						offset:twentyPercentHeight
					});
					return
				}
				let data = {
					pwd: this.pwdDown,
					product_id:this.id,
					file_id:this.file_id
				};
				// this.$startLoading();
				check_cy_pwd_api(data).then(res => {
					console.log(res)
					// let list = localStorage.getItem('downLoadIdList') || [];
					// list.push(this.id);
					// const uniqueArray = [...new Set(list)];
					// localStorage.setItem('downLoadIdList', uniqueArray);
					t.dialogVisible = false;
					// if (res.msg) {
					// 	this.$message.success(res.msg)
					// }
					setTimeout(function() {
						// t.$emit('pwdDownLoad')
						window.open(res.data.file_url, '_blank');
					}, 1500)
					// this.$endLoading();
				}).catch(err => {
					// this.$endLoading();
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.pwdModelBox {
		text-align: center;

		.pwdModelBoxOne {
			font-family: Source Han Sans CN;
			font-weight: bold;
			font-size: 28px;
			color: #0E0B0A;
			margin-bottom: 41px;
		}

		.pwdModelBoxTwo {
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #FF0000;
			margin-bottom: 10px;
		}

		.pwdModelBoxThree {
			width: 80%;
			margin: 0 auto 22px;
		}

		.pwdModelBoxFour {
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
			width: 80%;
			margin: 0 auto 29px;
			white-space: pre-line;
		}

		.pwdModelBoxFive {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;

			>div {
				width: 33%;
				height: 40px;
				background: #000000;
				border-radius: 5px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}
		}
	}
	.pwdModelBoxThreeImg{
		display: flex;
		align-items: center;
		height: 40px;
		padding-right: 10px;
		img{
			width: 24px;
			height: 24px;
			object-fit: contain;
		}
	}
	@media screen and (max-width:1200px) {}
</style>